import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summary", "detail"]

  toggle() {
    this.detailTarget.classList.toggle("hidden")
  }

  collapse() {
    this.detailTarget.classList.add("hidden")
  }
}
